// Resolução pura da citação (quoted reply). Sem React, sem I/O.
// preview pode ser o conteúdo OU uma chave i18n 'panel.citacao.media.<tipo>'
// (o componente faz t() quando começa por 'panel.').

export interface MsgCitavel {
  bsp_message_id: string | null;
  remetente: string;
  conteudo: string;
  tipo_media?: string | null;
  media_storage_path?: string | null;
  nome_remetente?: string | null;
}

export interface Citacao {
  autor: string;
  preview: string;
  /** Para mostrar miniatura da imagem citada (resolve-se em signed URL na UI). */
  tipoMedia: string | null;
  mediaStoragePath: string | null;
}

const ROTULO_MEDIA: Record<string, string> = {
  image: 'panel.citacao.media.image',
  audio: 'panel.citacao.media.audio',
  video: 'panel.citacao.media.video',
  document: 'panel.citacao.media.document',
};

export function previewDeMensagem(
  msg: MsgCitavel,
  nomeCliente: string,
  nomeProprio: string,
): Citacao {
  const autor = msg.remetente === 'cliente' ? nomeCliente : (msg.nome_remetente || nomeProprio);
  const preview = msg.conteudo
    ? msg.conteudo
    : (msg.tipo_media ? (ROTULO_MEDIA[msg.tipo_media] ?? '') : '');
  return {
    autor,
    preview,
    tipoMedia: msg.tipo_media ?? null,
    mediaStoragePath: msg.media_storage_path ?? null,
  };
}

export function resolverCitacao(
  mensagens: MsgCitavel[],
  replyToBspId: string | null | undefined,
  nomeCliente: string,
  nomeProprio: string,
): Citacao | null {
  if (!replyToBspId) return null;
  const alvo = mensagens.find((m) => m.bsp_message_id === replyToBspId);
  if (!alvo) return null;
  return previewDeMensagem(alvo, nomeCliente, nomeProprio);
}
